








import { Component, Vue, Prop } from 'vue-property-decorator';
import Loader from './Loader.vue';

@Component({
  components: {
    Loader
  }
})
export default class FullPageLoader extends Vue {
  @Prop({ required: true, default: 100 })
  width!: number;

  @Prop({ required: true, default: 100 })
  height!: number;

  @Prop({ required: true, default: false })
  show!: boolean;
}
